import moment from 'moment-timezone';

export const DUPLICATE_ORDER_WINDOW_MINUTES = 60;
export const RECENT_ORDERS_LIMIT = 10;

const getTravelDate = (fare) => {
    if (!fare.outwardJourney) {
        return '';
    }

    if (fare.isAdvance()) {
        const departure = fare.getDepartureTime();
        return departure ? departure.toISOString() : '';
    }

    const validFrom = fare.getValidFrom();
    return validFrom ? moment(validFrom).format('YYYY-MM-DD') : '';
};

const getRailcardSignature = (fare) =>
    fare.tickets
        .map((ticket) => ticket.railcard?.code)
        .filter(Boolean)
        .sort()
        .join(',');

const getFareSignature = (fare) => [
    fare.ticketType?.code,
    fare.route?.code,
    fare.isFirstClass() ? 'first' : 'standard',
    fare.adults(),
    fare.children(),
    getRailcardSignature(fare),
    getTravelDate(fare),
].join('|');

const getTripSignature = (trip) => [
    trip.getFirstOrigin()?.nlc,
    trip.getDestination()?.nlc,
    ...trip.getJourneyFares().map(getFareSignature).sort(),
].join('|');

export const getOrderSignature = (order) => {
    const trips = order?.trips;
    if (!trips) {
        return null;
    }

    const tripSignatures = trips
        .filter((trip) => trip.getJourneyFares().size)
        .map(getTripSignature)
        .sort();

    return tripSignatures.size ? tripSignatures.join('~') : null;
};

export const hasRecentMatch = ({ signature, recentOrders, orderId = null, now = moment() }) => {
    if (!signature) {
        return false;
    }

    const cutoff = moment(now).subtract(DUPLICATE_ORDER_WINDOW_MINUTES, 'minutes');

    return recentOrders.some(
        (recent) =>
            recent.orderId !== orderId &&
            recent.signature === signature &&
            recent.paidAt &&
            moment(recent.paidAt).isAfter(cutoff),
    );
};
